import React, { useEffect, useMemo, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import TimezoneSelect from "react-timezone-select";
import {
  fetchDesignationDetails,
  fetchSkillDetails,
} from "../../../Redux/action/MasterSkillAction";
import { useStatesByCountry } from "../../../Hooks/useStatesByCountry";
import { useCountries } from "../../../Hooks/useCountries";
import { Button, Form, Modal } from "react-bootstrap";
import { CreateJobFormAction } from "../../../Redux/action/CreateJobFormAction";
import { postLaterApi } from "../../../Services/JobServices";
import { useCitiesByState } from "../../../Hooks/useCitiesByState";
import RichTextEditor from "../../Common/RichTextEditor";

const CreateJobForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* -------------------- REDUX -------------------- */
  const AllSkillList = useSelector(
    (state) => state?.MasterTableDetails?.skill?.content,
  );
  const AllDesignationList = useSelector(
    (state) => state?.MasterTableDetails?.designation?.content,
  );
  const { userResult } = useSelector((state) => state.Auth);
  const vendorId = userResult?.vendorid;

  /* -------------------- STATE -------------------- */
  const [selectedTimezone, setSelectedTimezone] = useState({
    value: "",
    label: "",
  });
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedWork, setSelectedWork] = useState([]);
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [disabled2, setDisabled2] = useState(false);
  const [postLateerModal, setpostLateerModal] = useState(false);
  const [date, setDatePl] = useState("");
  const [time, setTime] = useState("");

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [data, setData] = useState({
    jobTitle: "",
    minimumExperience: "",
    maximumExperience: "",
    requiredSkills: [],
    jobDescription: "",
    workType: "",
    jobType: "",
    employmentType: "",
    workingDays: "",
    workingWeekDays: [],
    shiftTime: "",
    flexibleHours: "",
    validity: "",
    openingTime: "",
    closingTime: "",
    jobsPostedStatus: "",
    country: "",
    state: "",
    city: "",
  });

  const {
    openingTime,
    closingTime,
    minimumExperience,
    maximumExperience,
    jobTitle,
    country,
    state,
    city,
    validity,
    workType,
    jobDescription,
    shiftTime,
    jobType,
    employmentType,
    workingDays,
    workingWeekDays,
  } = data;

  /* -------------------- DATA HOOKS -------------------- */
  const { data: countriesData } = useCountries();
  const { data: stateList } = useStatesByCountry(country || "India");
  const { data: rawCities = [] } = useCitiesByState(country, state);

  /* -------------------- HELPERS -------------------- */
  const getTomorrowDate = useCallback(() => {
    const t = new Date();
    t.setDate(t.getDate() + 1);
    return t.toISOString().split("T")[0];
  }, []);

  const minDate = getTomorrowDate();
  const maxDate = validity || undefined;

  const listMin = useMemo(
    () => Array.from({ length: 31 }, (_, i) => `${i} years`),
    [],
  );
  const list = useMemo(
    () => Array.from({ length: 30 }, (_, i) => `${i + 1} years`),
    [],
  );

  const cleanCityList = useCallback((cities = []) => {
    return [
      ...new Set(
        cities.filter(Boolean).map((c) =>
          c
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-zA-Z\s.-]/g, "")
            .replace(/\s+/g, " ")
            .trim(),
        ),
      ),
    ].sort();
  }, []);

  const citiesList = useMemo(
    () => cleanCityList(rawCities),
    [rawCities, cleanCityList],
  );

  /* -------------------- EFFECTS -------------------- */
  useEffect(() => {
    dispatch(fetchSkillDetails());
    dispatch(fetchDesignationDetails());
  }, [dispatch]);

  useEffect(() => {
    if (workType === "REMOTE") {
      setData((p) => ({ ...p, country: "", state: "", city: "" }));
    }
  }, [workType]);

  useEffect(() => {
    setData((p) => ({ ...p, state: "", city: "" }));
  }, [country]);

  useEffect(() => {
    if (jobType === "FULL_TIME") {
      setData((p) => ({
        ...p,
        shiftTime: "",
        openingTime: "",
        closingTime: "",
      }));
    }
  }, [jobType]);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setData((p) => ({ ...p, [name]: value }));
  }, []);

  const handleSkillsChange = useCallback((opts) => {
    setSelectedSkills(opts);
    setData((p) => ({ ...p, requiredSkills: opts.map((o) => o.value) }));
  }, []);

  const handleSkillsChange1 = useCallback((opts) => {
    setSelectedWork(opts);
    setData((p) => ({ ...p, workingWeekDays: opts.map((o) => o.value) }));
  }, []);

  const handleFileChange = useCallback((e) => {
    const f = e.target.files[0];
    if (!f) return;
    if (f.size / 1024 / 1024 > 1) {
      toast.error("File size should be less than 1MB");
      e.target.value = null;
      return;
    }
    setFile(f);
  }, []);

  const handleClose = () => {
    setpostLateerModal(false);
    setDatePl("");
    setTime("");
  };

  const validateForm = () => {
    if (!workType) return "Work Type is required";
    if (!employmentType) return "Employment Type is required";
    if (!jobTitle) return "Job Title is required";

    if (workType !== "REMOTE") {
      if (!country) return "Country is required";
      if (!state) return "State is required";
      if (!city) return "City is required";
    }

    if (!minimumExperience) return "Minimum Experience is required";
    if (!maximumExperience) return "Maximum Experience is required";
    if (parseInt(maximumExperience) <= parseInt(minimumExperience)) {
      return "Maximum experience must be greater than Minimum experience";
    }

    if (!validity) return "Job Expiry Date is required";
    if (!jobType) return "Job Type (Full/Part time) is required";
    if (!workingDays) return "Working Days count is required";
    if (selectedWork.length === 0) return "Please select Working Week Days";
    if (parseInt(workingDays) !== selectedWork.length) {
      return `You selected ${workingDays} days but picked ${selectedWork.length} week days`;
    }

    if (jobType === "PART_TIME" || jobType === "FLEXIBLE") {
      if (!shiftTime)
        return "Shift Type is required for Part-time/Flexible jobs";
      if (!openingTime) return "Start Time is required";
      if (!closingTime) return "End Time is required";
    }

    if (!selectedTimezone?.label) return "Time zone is required";
    if (selectedSkills.length === 0) return "At least one Skill is required";
    if (
      !jobDescription ||
      jobDescription.trim() === "" ||
      jobDescription === "<p><br></p>"
    ) {
      return "Job Description is required";
    }

    return null; // All valid
  };

  /* -------------------- SUBMIT -------------------- */
  const handleSubmit = useCallback(
    (e, jobStatus) => {
      e.preventDefault();

      const error = validateForm();
      if (error) {
        toast.error(error);
        return;
      }

      const jobsData = {
        vendorId,
        ...data,
        jobsPostedStatus: jobStatus,
        jobLocation:
          workType === "REMOTE" ? "Remote" : `${city}, ${state}, ${country}`,
        timeZone: selectedTimezone.label,
        jobType: employmentType,
        employmentType: jobType,
      };

      const formData = new FormData();
      formData.append("jobs", JSON.stringify(jobsData));
      if (file) formData.append("file", file);

      if (jobStatus === "ONHOLD") setDisabled2(true);
      else setDisabled(true);

      dispatch(CreateJobFormAction(formData, navigate)).finally(() => {
        setDisabled(false);
        setDisabled2(false);
      });
    },
    [
      data,
      vendorId,
      city,
      state,
      country,
      selectedTimezone,
      employmentType,
      jobType,
      file,
      minimumExperience,
      maximumExperience,
      workingDays,
      selectedWork,
      selectedSkills,
      dispatch,
      navigate,
      workType,
    ],
  );

  const submitPostLater = useCallback(() => {
    const error = validateForm();
    if (error) {
      toast.error(error);
      return;
    }

    const formData = new FormData();
    formData.append(
      "jobs",
      JSON.stringify({
        vendorId,
        ...data,
        jobsPostedStatus: "POSTLATER",
        postLaterDate: date,
        postLaterTime: time,
        timeZone: selectedTimezone.label,
        zoneId: timeZone,
        jobType: employmentType,
        employmentType: jobType,
      }),
    );
    if (file) formData.append("file", file);

    postLaterApi(formData).then(() =>
      navigate("/posted_jobs?active=post-later"),
    );
  }, [
    date,
    time,
    data,
    vendorId,
    selectedTimezone,
    timeZone,
    employmentType,
    jobType,
    file,
    navigate,
  ]);

  /* -------------------- OPTIONS -------------------- */
  const skillOptions = useMemo(
    () =>
      AllSkillList?.map((s) => ({ value: s.skillName, label: s.skillName })),
    [AllSkillList],
  );

  const WeekOptions = useMemo(
    () =>
      [
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
        "SUNDAY",
      ].map((d) => ({ value: d, label: d })),
    [],
  );

  const selectStyles = {
    multiValue: (styles) => ({ ...styles, backgroundColor: "#286a94" }),
    multiValueLabel: (styles) => ({ ...styles, color: "white" }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "white",
      ":hover": { backgroundColor: "#1a4b6d", color: "white" },
    }),
  };

  return (
    <div className="d-flex flex-column flex-md-row gap-4 container mt-4">
      <div className="can_prof_container w-100">
        <div className="card can_prof_main">
          <div className="card-header prof_header d-flex justify-content-between">
            Create New Job
          </div>
          <div className="card-body">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="row gx-3 gy-3 mb-3">
                <div className="col-12 col-lg-4 col-sm-6">
                  <label className="small mb-1 d-block">
                    Work Type <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex gap-4">
                    {["REMOTE", "ONSITE", "HYBRID"].map((type) => (
                      <div className="form-check form-check-inline" key={type}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="workType"
                          id={`workType${type}`}
                          value={type}
                          checked={workType === type}
                          onChange={handleInputChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`workType${type}`}
                        >
                          {type}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-12 col-lg-4 col-sm-6">
                  <label className="small mb-1">
                    Employment Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="employmentType"
                    value={employmentType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Employment Type</option>
                    <option value="PERMANENT">Permanent</option>
                    <option value="CONTRACT">Contract</option>
                    <option value="FREELANCE">Freelance</option>
                    <option value="INTERNSHIP">Internship</option>
                  </select>
                </div>

                <div className="col-12 col-lg-4 col-sm-6">
                  <label className="small mb-1">
                    Job Title <span className="text-danger">*</span>
                  </label>
                  <select
                    name="jobTitle"
                    value={jobTitle}
                    required
                    onChange={handleInputChange}
                    className="form-select"
                  >
                    <option value="" disabled hidden>
                      Select job title
                    </option>
                    {AllDesignationList?.map((opt) => (
                      <option key={opt.designationId} value={opt.designation}>
                        {opt.designation}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row gx-3 mb-3">
                <div className="col-md-3">
                  <label className="small mb-1">
                    Country <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="country"
                    value={country}
                    onChange={handleInputChange}
                    required
                    disabled={workType === "REMOTE"}
                  >
                    <option value="" disabled>
                      Select country
                    </option>
                    {countriesData?.data?.map((opt) => (
                      <option key={opt.country} value={opt.country}>
                        {opt.country}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="small mb-1">
                    State <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="state"
                    value={state}
                    onChange={handleInputChange}
                    required
                    disabled={workType === "REMOTE"}
                  >
                    <option value="" disabled>
                      Select state
                    </option>
                    {stateList?.data?.states?.map((opt) => (
                      <option key={opt.name} value={opt.name}>
                        {opt.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label className="small mb-1">
                    City <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="city"
                    value={city}
                    onChange={handleInputChange}
                    required
                    disabled={workType === "REMOTE"}
                  >
                    <option value="" disabled>
                      Select city
                    </option>
                    {citiesList?.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-md-3">
                  <label className="small mb-1">
                    Min Exp <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="minimumExperience"
                    value={minimumExperience}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Min Exp</option>
                    {listMin.map((item, i) => (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row gx-3 mb-3">
                <div className="col-12 col-md-3 mt-3">
                  <label className="small mb-1">
                    Max Exp <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="maximumExperience"
                    value={maximumExperience}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Max Exp</option>
                    {list.map((item, i) => (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-md-3 mt-3">
                  <label className="small mb-1">
                    Job Expiry Date <span className="text-danger">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="date"
                    name="validity"
                    value={validity}
                    onChange={handleInputChange}
                    min={minDate}
                    required
                  />
                </div>
                <div className="col-12 col-md-3 mt-3">
                  <label className="small mb-1">
                    Job Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="jobType"
                    value={jobType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" disabled>
                      Select Job Type
                    </option>
                    <option value="FULL_TIME">Full Time</option>
                    <option value="PART_TIME">Part Time</option>
                    <option value="FLEXIBLE">Flexible Time</option>
                  </select>
                </div>
                <div className="col-12 col-md-3 mt-3">
                  <label className="small mb-1">
                    Working Days <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    name="workingDays"
                    value={workingDays}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" disabled>
                      Select days
                    </option>
                    {[1, 2, 3, 4, 5, 6].map((d) => (
                      <option key={d} value={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {(jobType === "PART_TIME" || jobType === "FLEXIBLE") && (
                <div className="row gx-3 mb-3">
                  <div className="col-md-4">
                    <label className="small mb-1">
                      Shift Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      name="shiftTime"
                      value={shiftTime}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" disabled>
                        Select shift type
                      </option>
                      <option value="sameDay">
                        Same Day (e.g., 09:00 – 17:00)
                      </option>
                      <option value="overnight">
                        Overnight (e.g., 23:00 – 07:00)
                      </option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="small mb-1">
                      Start Time <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="time"
                      name="openingTime"
                      value={openingTime}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="small mb-1">
                      End Time <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="time"
                      name="closingTime"
                      value={closingTime}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              )}

              <div className="row gx-3 mb-3">
                <div className="col-12 col-md-4 mt-3">
                  <label>
                    Working Week Days <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={WeekOptions}
                    isMulti
                    onChange={handleSkillsChange1}
                    value={selectedWork}
                    styles={selectStyles}
                    required
                  />
                </div>
                <div className="col-12 col-md-4 mt-3">
                  <label>
                    Time zone <span className="text-danger">*</span>
                  </label>
                  <TimezoneSelect
                    value={selectedTimezone}
                    onChange={setSelectedTimezone}
                    labelStyle="altName"
                  />
                </div>
                <div className="col-12 col-md-4 mt-3">
                  <label>
                    Skills <span className="text-danger">*</span>
                  </label>
                  <Select
                    options={skillOptions}
                    isMulti
                    onChange={handleSkillsChange}
                    value={selectedSkills}
                    styles={selectStyles}
                    required
                  />
                </div>
              </div>

              <div className="row gx-3 mb-3" style={{ minHeight: "200px" }}>
                <RichTextEditor
                  name="jobDescription"
                  value={jobDescription}
                  onChange={handleInputChange}
                  required
                  maxLength={5000}
                />
              </div>

              <div className="row gx-3 mb-3">
                <div className="col-12">
                  <label className="small mb-1">Upload Assignment</label>
                  <input
                    className="form-control"
                    type="file"
                    accept="application/pdf, image/*"
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  type="button"
                  disabled={disabled}
                  className="can_update_prof_btn add_skill_btn"
                  onClick={(e) => handleSubmit(e, "POSTED")}
                >
                  {disabled ? "Loading..." : "Post Job"}
                </button>
                <button
                  type="button"
                  disabled={disabled2}
                  className="can_update_prof_btn add_skill_btn"
                  onClick={(e) => handleSubmit(e, "ONHOLD")}
                >
                  {disabled2 ? "Loading..." : "Save as Draft"}
                </button>
                <button
                  type="button"
                  onClick={() => setpostLateerModal(true)}
                  className="can_update_prof_btn add_skill_btn"
                >
                  Post Later
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Modal
        show={postLateerModal}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Post Later</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Select Date</Form.Label>
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDatePl(e.target.value)}
              min={minDate}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Select Time</Form.Label>
            <Form.Control
              type="time"
              value={time}
              onChange={(e) => setTime(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center" }}>
          <Button variant="success" onClick={submitPostLater}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreateJobForm;
